// import React, { useState, useEffect } from 'react';
// import { FaBars, FaTimes } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';

// const Navigation = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 20);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToSection = (id) => {
//     const scrollToElement = () => {
//       const element = document.getElementById(id);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//         setIsMobileMenuOpen(false);
//       }
//     };

//     if (window.location.pathname !== '/') {
//       navigate('/');
//       setTimeout(scrollToElement, 500);
//     } else {
//       scrollToElement();
//     }
//   };

//   return (
//     <nav
//       data-testid="main-navigation"
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
//         isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
//       }`}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-between items-center h-20">

//           {/* Logo */}
//           <Link to="/" className="flex-shrink-0">
//             <img
//               src="/images/vlinkinllplogo.png"
//               alt="Vlinkin Professionals"
//               className="h-24 w-auto"
//             />
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex space-x-8 items-center">

//             <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium">
//               Home
//             </Link>

//             <button onClick={() => scrollToSection('programs')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Our Programs
//             </button>

//             <Link to="/team" className="text-gray-700 hover:text-blue-600 font-medium">
//               Our Team
//             </Link>

//             <Link to="/gallery" className="text-gray-700 hover:text-blue-600 font-medium">
//               Gallery
//             </Link>

//             <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Testimonials
//             </button>

//             <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Contact Us
//             </button>

//             <Link to="/blog" className="text-gray-700 hover:text-blue-600 font-medium">
//               Blog
//             </Link>

//             {/* Admin Login (NO CHANGE) */}
//             <button
//               onClick={() => navigate('/admin-login')}
//               className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
//             >
//               Admin Login
//             </button>

//           </div>

//           {/* Enroll Now (🔴 CHANGED TO GREEN) */}
//           <div className="hidden md:block">
//             <button
//               onClick={() => scrollToSection('contact')}
//               className="bg-green-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-green-700 hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
//             >
//               Enroll Now
//             </button>
//           </div>

//           {/* Mobile Menu Button */}
//           <div className="md:hidden">
//             <button
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//               className="text-gray-700"
//             >
//               {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-white border-t">
//           <div className="px-4 pt-2 pb-4 space-y-2">

//             <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Home
//             </Link>

//             <button onClick={() => { scrollToSection('programs'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Our Programs
//             </button>

//             <Link to="/team" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Our Team
//             </Link>

//             <Link to="/gallery" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Gallery
//             </Link>

//             <button onClick={() => { scrollToSection('testimonials'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Testimonials
//             </button>

//             <button onClick={() => { scrollToSection('contact'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Contact Us
//             </button>

//             <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Blog
//             </Link>

//             {/* Admin Login (NO CHANGE) */}
//             <button
//               onClick={() => {
//                 navigate('/admin-login');
//                 setIsMobileMenuOpen(false);
//               }}
//               className="block w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-2 rounded-lg font-semibold mt-2"
//             >
//               Admin Login
//             </button>

//             {/* Enroll Now (GREEN) */}
//             <button
//               onClick={() => {
//                 scrollToSection('contact');
//                 setIsMobileMenuOpen(false);
//               }}
//               className="block w-full bg-green-600 text-white px-3 py-2 rounded-lg font-semibold mt-2 hover:bg-green-700"
//             >
//               Enroll Now
//             </button>

//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navigation;
// import React, { useState, useEffect } from 'react';
// import { FaBars, FaTimes } from 'react-icons/fa';
// import { Link, useNavigate } from 'react-router-dom';

// const Navigation = () => {
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 20);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const scrollToSection = (id) => {
//     const scrollToElement = () => {
//       const element = document.getElementById(id);
//       if (element) {
//         element.scrollIntoView({ behavior: 'smooth' });
//         setIsMobileMenuOpen(false);
//       }
//     };

//     if (window.location.pathname !== '/') {
//       navigate('/');
//       setTimeout(scrollToElement, 500);
//     } else {
//       scrollToElement();
//     }
//   };

//   return (
//     <nav
//       data-testid="main-navigation"
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
//         isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
//       }`}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex justify-between items-center h-20">

//           {/* Logo */}
//           <Link to="/" className="flex-shrink-0">
//             <img
//               src="/images/vlinkinllplogo.png"
//               alt="Vlinkin Professionals"
//               className="h-24 w-auto"
//             />
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex space-x-8 items-center">

//             <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium">
//               Home
//             </Link>

//             <button onClick={() => scrollToSection('programs')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Our Programs
//             </button>

//             <Link to="/team" className="text-gray-700 hover:text-blue-600 font-medium">
//               Our Team
//             </Link>

//             <Link to="/gallery" className="text-gray-700 hover:text-blue-600 font-medium">
//               Gallery
//             </Link>

//             <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Testimonials
//             </button>

//             <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 font-medium">
//               Contact Us
//             </button>

//             <Link to="/blog" className="text-gray-700 hover:text-blue-600 font-medium">
//               Blog
//             </Link>

//             {/* Student Login */}
//             <button
//               onClick={() => navigate('/student/login')}
//               className="border-2 border-blue-600 text-blue-600 px-6 py-2 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-all"
//             >
//               Student Login
//             </button>

//             {/* Admin Login (NO CHANGE) */}
//             <button
//               onClick={() => navigate('/admin-login')}
//               className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
//             >
//               Admin Login
//             </button>

//           </div>

//           {/* Enroll Now (🔴 CHANGED TO GREEN) */}
//           <div className="hidden md:block">
//             <button
//               onClick={() => scrollToSection('contact')}
//               className="bg-green-600 text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-green-700 hover:shadow-lg transform hover:-translate-y-0.5 transition-all"
//             >
//               Enroll Now
//             </button>
//           </div>

//           {/* Mobile Menu Button */}
//           <div className="md:hidden">
//             <button
//               onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//               className="text-gray-700"
//             >
//               {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMobileMenuOpen && (
//         <div className="md:hidden bg-white border-t">
//           <div className="px-4 pt-2 pb-4 space-y-2">

//             <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Home
//             </Link>

//             <button onClick={() => { scrollToSection('programs'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Our Programs
//             </button>

//             <Link to="/team" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Our Team
//             </Link>

//             <Link to="/gallery" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Gallery
//             </Link>

//             <button onClick={() => { scrollToSection('testimonials'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Testimonials
//             </button>

//             <button onClick={() => { scrollToSection('contact'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2">
//               Contact Us
//             </button>

//             <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2">
//               Blog
//             </Link>

//             {/* Student Login */}
//             {/* Student Login */}
// <button
//   onClick={() => navigate('/student/login')}
//   className="border-2 border-blue-600 text-blue-600 px-6 py-2 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-all"
// >
//   Student Login
// </button>

//             {/* Admin Login (NO CHANGE) */}
//             <button
//               onClick={() => {
//                 navigate('/admin-login');
//                 setIsMobileMenuOpen(false);
//               }}
//               className="block w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-2 rounded-lg font-semibold mt-2"
//             >
//               Admin Login
//             </button>

//             {/* Enroll Now (GREEN) */}
//             <button
//               onClick={() => {
//                 scrollToSection('contact');
//                 setIsMobileMenuOpen(false);
//               }}
//               className="block w-full bg-green-600 text-white px-3 py-2 rounded-lg font-semibold mt-2 hover:bg-green-700"
//             >
//               Enroll Now
//             </button>

//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navigation;
import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const scrollToElement = () => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    };

    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(scrollToElement, 500);
    } else {
      scrollToElement();
    }
  };

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">

          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img
              src="/images/vlinkinllplogo.png"
              alt="Vlinkin Professionals"
              className="h-24 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-5">

            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Home
            </Link>

            <button onClick={() => scrollToSection('programs')} className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Our Programs
            </button>

            <Link to="/team" className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Our Team
            </Link>

            <Link to="/gallery" className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Gallery
            </Link>

            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Testimonials
            </button>

            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Contact Us
            </button>

            <Link to="/blog" className="text-gray-700 hover:text-blue-600 font-medium text-sm">
              Blog
            </Link>

            {/* Divider */}
            <div className="h-6 w-px bg-gray-200 mx-1" />

            {/* Student Login */}
            <button
              onClick={() => navigate('/student/login')}
              className="border border-blue-600 text-blue-600 px-3.5 py-1.5 rounded-md text-sm font-semibold hover:bg-blue-600 hover:text-white transition-all"
            >
              Student Login
            </button>

            {/* Admin Login */}
            <button
              onClick={() => navigate('/admin-login')}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3.5 py-1.5 rounded-md text-sm font-semibold hover:shadow-md transform hover:-translate-y-0.5 transition-all"
            >
              Admin Login
            </button>

            {/* Enroll Now */}
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-green-600 text-white px-3.5 py-1.5 rounded-md text-sm font-semibold hover:bg-green-700 hover:shadow-md transform hover:-translate-y-0.5 transition-all"
            >
              Enroll Now
            </button>

          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-700"
            >
              {isMobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 pt-2 pb-4 space-y-1">

            <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2 text-sm">
              Home
            </Link>

            <button onClick={() => { scrollToSection('programs'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-sm">
              Our Programs
            </button>

            <Link to="/team" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2 text-sm">
              Our Team
            </Link>

            <Link to="/gallery" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2 text-sm">
              Gallery
            </Link>

            <button onClick={() => { scrollToSection('testimonials'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-sm">
              Testimonials
            </button>

            <button onClick={() => { scrollToSection('contact'); setIsMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-sm">
              Contact Us
            </button>

            <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-2 text-sm">
              Blog
            </Link>

            <div className="h-px bg-gray-200 my-2" />

            {/* Student Login */}
            <button
              onClick={() => {
                navigate('/student/login');
                setIsMobileMenuOpen(false);
              }}
              className="block w-full border border-blue-600 text-blue-600 px-3 py-2 rounded-md text-sm font-semibold"
            >
              Student Login
            </button>

            {/* Admin Login */}
            <button
              onClick={() => {
                navigate('/admin-login');
                setIsMobileMenuOpen(false);
              }}
              className="block w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 py-2 rounded-md text-sm font-semibold mt-2"
            >
              Admin Login
            </button>

            {/* Enroll Now */}
            <button
              onClick={() => {
                scrollToSection('contact');
                setIsMobileMenuOpen(false);
              }}
              className="block w-full bg-green-600 text-white px-3 py-2 rounded-md text-sm font-semibold mt-2 hover:bg-green-700"
            >
              Enroll Now
            </button>

          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;